export const baseCDNURL = 'https://cdn.myfunnow.com'

const prefix = (path) => {
  return (path.substring(0, 1) !== '/') ? '/' + path : path
}

const isEmpty = (s) => {
  return s === '' || s === null || s === undefined
}

const parsePath = (path, def) => {
  let res = {
    path: '',
    fname: ''
  }
  if (def !== undefined) {
    res = def
  }
  if (isEmpty(path)) {
    return res
  }

  let i = path.lastIndexOf('/')
  if (i !== -1) {
    res.path = prefix(path.substr(0, i + 1))
    res.fname = encodeURIComponent(path.substr(i + 1))
  }

  return res
}

export const parseImagePath = (path) => {
  return parsePath(path, {
    path: 'images/',
    fname: 'image.png'
  })
}

export const getFileURL = (path) => {
  if (!isEmpty(path)) {
    let res = parsePath(path)
    return baseCDNURL + res.path + res.fname
  }
  return path
}

export const getImgURL = (path) => {
  if (!isEmpty(path)) {
    let res = parseImagePath(path)
    return baseCDNURL + res.path + res.fname
  }
  return path
}

export const getThumbnail = (path) => {
  if (!isEmpty(path)) {
    let res = parseImagePath(path)
    return baseCDNURL + res.path + 'thumbnail/' + res.fname
  }
  return path
}

export const getURLString = (path) => {
  if (!isEmpty(path)) {
    path = prefix(path)
    return baseCDNURL + path.replace(/#/g, '%23')
  }
  return path
}
